var _defs, _path, _rect, _path2, _path3, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToughEnoughLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_31143",
    "data-name": "Group 31143",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256.59,
    height: 45.273,
    viewBox: "0 0 256.59 45.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4688",
    "data-name": "Rectangle 4688",
    width: 256.589,
    height: 45.273,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140277",
    "data-name": "Path 140277",
    d: "M6.557,18.268v.9H234.509V18.161Z",
    transform: "translate(-6.557 -18.161)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4679",
    "data-name": "Rectangle 4679",
    width: 227.951,
    height: 1.01,
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 105 1"
  }, /*#__PURE__*/React.createElement("image", {
    width: 105,
    height: 1,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGkAAAABCAYAAADdJYANAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAaaADAAQAAAABAAAAAQAAAABPH6dUAAAAEklEQVQYGWP8//8/wygY3CEAAOedAv8RNifnAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4683",
    "data-name": "Rectangle 4683",
    width: 227.952,
    height: 0.075,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4682",
    "data-name": "Rectangle 4682",
    width: 227.951,
    height: 0.075,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140278",
    "data-name": "Path 140278",
    d: "M5.561,36.13H235.693v-1H5.561Zm0-32.7H235.693V2.946H5.561Z",
    transform: "translate(-5.561 -2.946)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4686",
    "data-name": "Rectangle 4686",
    width: 230.135,
    height: 33.184,
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-3",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 106 16"
  }, /*#__PURE__*/React.createElement("image", {
    width: 106,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAAAQCAYAAAD+mOowAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAaqADAAQAAAABAAAAEAAAAABBBULiAAAAnElEQVRYCe2ZwQ2AIBAE7wQLsRdLMKE1HxaqoqJLCcQHm+yRmPiATHbcD3opxbZ1m03TdQIOUZr+Exj6RxQhEpAoku9AoiSKJAESTDVKokgSIMFUoySKJAESTDVKokgSIMFUoySKJAESTDWKRFQEZ1rS1Mz7Xb6f+bL7KYaF8W/FMFiMwdybT/5lI34O7EeuZ4EPbJhxDJWxvhA8XimHGVKQnNbcAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28927",
    "data-name": "Group 28927",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_140273",
    "data-name": "Path 140273",
    d: "M9.321,2.941l-6.053,5.8L2.9,29.875l8.019,6.261,229.429-.813,6.053-5.8V8.742l-6.419-5.45Z",
    transform: "translate(3.458 3.504)",
    fill: "#0b0c0c"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4675",
    "data-name": "Rectangle 4675",
    width: 232.613,
    height: 3.719,
    transform: "translate(11.988 1.427)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140274",
    "data-name": "Path 140274",
    d: "M10.421.993H246.166l.758.725,7.87,7.541.756.728v25.3l-.756.725-7.87,7.543-.758.725H10.421l-.756-.725L1.793,36.012l-.758-.725V9.987l.758-.728L9.665,1.718ZM9.993,0,8.933,1.017,1.061,8.558,0,9.575V35.7l1.061,1.019,7.872,7.541,1.061,1.017h236.6l1.063-1.017,7.87-7.541,1.063-1.019V9.575l-1.063-1.017-7.87-7.541L246.593,0Z",
    fill: "#0b0c0c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140275",
    "data-name": "Path 140275",
    d: "M10.087,2.123l-.732-.7L1.181,9.255v24.07l8.477,8.124H244.116l8.479-8.124V9.255l-8.479-8.124H9.658l-.3.291.732.7v.993H243.259l7.265,6.96V32.5l-7.265,6.963H10.517L3.252,32.5V10.077l7.567-7.252-.732-.7v0Z",
    transform: "translate(1.407 1.347)",
    fill: "#0b0c0c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28903",
    "data-name": "Group 28903",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28902",
    "data-name": "Group 28902",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140276",
    "data-name": "Path 140276",
    d: "M9.4,3.21,9.037,2.86q-3.028,2.9-6.053,5.8l-.151.145V30l.151.147,6.053,5.8.151.147H240.647l.151-.147,6.055-5.8L247,30V8.805l-.151-.145q-3.028-2.9-6.055-5.8l-.151-.145H9.188l-.151.145L9.4,3.21v.5H240.432v-.5l-.366.351q3.028,2.9,6.053,5.8l.366-.351h-.517V29.794h.517l-.366-.353q-3.024,2.9-6.053,5.8l.366.351v-.5H9.4v.5l.366-.351-6.053-5.8-.366.353h.517V9.011H3.35l.366.351q3.028-2.9,6.053-5.8L9.4,3.21v0Z",
    transform: "translate(3.376 3.235)",
    fill: "#0b0c0c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28910",
    "data-name": "Group 28910",
    transform: "translate(14.37 39.801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28909",
    "data-name": "Group 28909",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28908",
    "data-name": "Group 28908",
    transform: "translate(0.001 -0.001)",
    style: {
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28907",
    "data-name": "Group 28907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28906",
    "data-name": "Group 28906",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28905",
    "data-name": "Group 28905",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28904",
    "data-name": "Group 28904",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4677",
    "data-name": "Rectangle 4677",
    width: 211.894,
    height: 1.01,
    fill: "url(#pattern)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28917",
    "data-name": "Group 28917",
    transform: "translate(14.37 40.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28916",
    "data-name": "Group 28916",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28915",
    "data-name": "Group 28915",
    transform: "translate(0.001 0.001)",
    style: {
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28914",
    "data-name": "Group 28914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28913",
    "data-name": "Group 28913",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28912",
    "data-name": "Group 28912",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28911",
    "data-name": "Group 28911",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4680",
    "data-name": "Rectangle 4680",
    width: 118.33,
    height: 0.075,
    fill: "url(#pattern)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28924",
    "data-name": "Group 28924",
    transform: "translate(12.187 6.456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28923",
    "data-name": "Group 28923",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28922",
    "data-name": "Group 28922",
    transform: "translate(0 -0.001)",
    style: {
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28921",
    "data-name": "Group 28921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28920",
    "data-name": "Group 28920",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28919",
    "data-name": "Group 28919",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28918",
    "data-name": "Group 28918",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4684",
    "data-name": "Rectangle 4684",
    width: 220.094,
    height: 33.184,
    fill: "url(#pattern-3)"
  }))))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28926",
    "data-name": "Group 28926",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28925",
    "data-name": "Group 28925",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140279",
    "data-name": "Path 140279",
    d: "M9.2,5.035A3.511,3.511,0,0,0,8.1,7.406h4.648l.05.048Q9.36,22.734,8.9,25.116q0,1.548,1.929,1.8l.859-.05,3.228-14.469a48.938,48.938,0,0,1,1.157-4.988h2.435a2.574,2.574,0,0,0,1.913-.874A4.145,4.145,0,0,0,21.178,4.5h-.05l-.039-.048H10.727A2.6,2.6,0,0,0,9.2,5.035m10.357,7.173a6.668,6.668,0,0,0-3.02,3.7A57.6,57.6,0,0,0,15.16,22.6a4.761,4.761,0,0,0,.548,2.233,4.274,4.274,0,0,0,3.853,2.084h1.484a6.52,6.52,0,0,0,4.166-1.523A7.453,7.453,0,0,0,27.24,22.5a50.392,50.392,0,0,0,1.433-6.974,5.916,5.916,0,0,0-.248-1.457q-1.095-2.758-4.609-2.757l-.39.05-.351-.05a7.665,7.665,0,0,0-3.515.9m-1.133,9.441q1-5.2,1.536-5.974a3.242,3.242,0,0,1,3.02-1.372h.338q2.189,0,2.187,1.271v.287a44.41,44.41,0,0,1-1.041,5.027q-.585,3.08-3.371,3.081h-.835q-1.94,0-1.937-1.473c0-.565.033-.848.1-.848M31.779,11.285l-.69,2.991Q29.4,21.736,29.4,22.436v.373a4.71,4.71,0,0,0,.4,1.858q1.147,2.245,4.725,2.246h.3a7.029,7.029,0,0,0,3.331-.712H38.2a2.185,2.185,0,0,0,1.692.712h.6l.05-.05Q43.221,14.9,43.519,13.181v-.088q0-1.634-1.887-1.808h-.741L38.443,22q-.858,1.959-3.826,1.959-2.084,0-2.084-1.571l1.94-9.2-.05-.476a1.8,1.8,0,0,0-1.992-1.42ZM44.948,15.3a43.993,43.993,0,0,0-1.381,6.487v.548a4.877,4.877,0,0,0,.234,1.422q.937,2.571,4.92,2.568a7.456,7.456,0,0,0,2.487-.46h.039l.05.048L50.832,27.6q-.756,1.821-3.449,1.821h-3.62a2.869,2.869,0,0,0-2.016.973,4.841,4.841,0,0,0-.611,1.819h.05l.053.05H47.76a7.346,7.346,0,0,0,2.878-.736,6.216,6.216,0,0,0,3.044-3.193q.3-.835,3.829-16.925c0-.09-.335-.136-1-.136a2.6,2.6,0,0,0-1.769.686H54.7a6.64,6.64,0,0,0-3.45-.686,6.415,6.415,0,0,0-6.3,4.028m2.577,1.734a3.269,3.269,0,0,1,3.592-2.919,7.03,7.03,0,0,1,1.328.125A1.288,1.288,0,0,1,53.5,15.612q0,.437-1.107,5.264-.805,2.558-3.1,2.558h-.82q-1.94,0-1.94-1.46.076-.874.988-4.94M61.163,4.45l-4.49,20.342v.287q.22,1.834,1.81,1.834h.806l.053-.05,1.51-6.761q.845-4.389,1.613-4.977.677-1.059,3.176-1.059,2.176,0,2.174,1.6-.1.986-1.913,9.031v.386q.21,1.834,1.81,1.834h.859l1.21-5.464a44.032,44.032,0,0,0,1.212-5.987v-.237a5.687,5.687,0,0,0-.248-1.547q-.989-2.607-5.247-2.606h-.053a7.225,7.225,0,0,0-2.615.423l-.053-.037,1.107-5.076-.105-.625A1.861,1.861,0,0,0,61.814,4.45Zm17.947.237a6.84,6.84,0,0,0-3.776,2.757,8.379,8.379,0,0,0-1.21,3.43q-2.472,10.562-2.472,11.685a4.517,4.517,0,0,0,.559,2.27,4.661,4.661,0,0,0,4.127,2.084h6.507c.123,0,.221-.388.3-1.162l-.1-.622a2.078,2.078,0,0,0-2.161-1.21H76.949q-2.124,0-2.121-1.547a51.415,51.415,0,0,1,1.054-5.214h7.666c.114,0,.213-.357.3-1.072l-.142-.811a2.023,2.023,0,0,0-2.071-1.122H76.546l1-4.341a3.292,3.292,0,0,1,3.476-2.369h6.156c.123,0,.221-.355.3-1.061q0-1.933-2.669-1.933H81.634a10.618,10.618,0,0,0-2.525.237m8.928,6.772q-2.867,12.784-2.97,13.607V25.3l.105.423A2.064,2.064,0,0,0,87.3,26.913h.39l.053-.05,2.279-10.191a3.291,3.291,0,0,1,3.371-2.419,5.12,5.12,0,0,1,1.926.287A1.109,1.109,0,0,1,96,15.675l-.053.66-1.823,8.582V25.3l.092.423a2.1,2.1,0,0,0,2.135,1.186h.34a8.885,8.885,0,0,0,.6-2.321,86.717,86.717,0,0,0,1.887-9.154,5.06,5.06,0,0,0-.3-1.659,4.267,4.267,0,0,0-4.114-2.419H93.232a6.028,6.028,0,0,0-2.722.609,2.053,2.053,0,0,0-1.431-.609h-.39a1.66,1.66,0,0,0-.651.1m16.305.75a6.668,6.668,0,0,0-3.02,3.7A57.6,57.6,0,0,0,99.943,22.6a4.735,4.735,0,0,0,.548,2.233,4.274,4.274,0,0,0,3.853,2.084h1.484a6.524,6.524,0,0,0,4.166-1.523,7.453,7.453,0,0,0,2.029-2.893,50.393,50.393,0,0,0,1.433-6.974,5.916,5.916,0,0,0-.248-1.457q-1.095-2.758-4.609-2.757l-.39.05-.351-.05a7.665,7.665,0,0,0-3.515.9m-1.133,9.441q1-5.2,1.536-5.974a3.242,3.242,0,0,1,3.02-1.372h.338q2.189,0,2.187,1.271v.287a44.407,44.407,0,0,1-1.041,5.027q-.585,3.08-3.371,3.081h-.833q-1.94,0-1.94-1.473c0-.565.033-.848.1-.848m13.351-10.364-.69,2.991q-1.693,7.459-1.692,8.159v.373a4.71,4.71,0,0,0,.4,1.858q1.147,2.245,4.725,2.246h.3a7.023,7.023,0,0,0,3.331-.712h.039a2.182,2.182,0,0,0,1.692.712h.6l.05-.05Q128,14.9,128.3,13.181v-.088q0-1.634-1.889-1.808h-.741L123.226,22q-.858,1.959-3.826,1.959-2.084,0-2.082-1.571l1.94-9.2-.053-.476a1.8,1.8,0,0,0-1.992-1.42Zm13.7,4.015a44.161,44.161,0,0,0-1.378,6.487v.548a4.8,4.8,0,0,0,.234,1.422q.937,2.571,4.92,2.568a7.453,7.453,0,0,0,2.485-.46h.039l.053.048-.469,1.685q-.756,1.821-3.449,1.821h-3.618a2.87,2.87,0,0,0-2.018.973,4.841,4.841,0,0,0-.611,1.819h.053l.053.05h6.52a7.337,7.337,0,0,0,2.878-.736A6.211,6.211,0,0,0,139,28.334q.3-.835,3.826-16.925c0-.09-.335-.136-1-.136a2.605,2.605,0,0,0-1.771.686h-.039a6.634,6.634,0,0,0-3.449-.686,6.417,6.417,0,0,0-6.3,4.028m2.577,1.734a3.271,3.271,0,0,1,3.594-2.919,7.031,7.031,0,0,1,1.328.125,1.29,1.29,0,0,1,1.054,1.372q0,.437-1.107,5.264-.809,2.558-3.1,2.558h-.82q-1.94,0-1.94-1.46.079-.874.988-4.94M146.48,4.45l-4.493,20.342v.287q.224,1.834,1.81,1.834h.807l.053-.05,1.51-6.761q.845-4.389,1.615-4.977.674-1.059,3.176-1.059,2.173,0,2.174,1.6-.105.986-1.913,9.031v.386q.207,1.834,1.808,1.834h.859L155.1,21.45a44.232,44.232,0,0,0,1.21-5.987v-.237a5.687,5.687,0,0,0-.248-1.547q-.989-2.607-5.244-2.606h-.053a7.237,7.237,0,0,0-2.617.423l-.053-.037L149.2,6.383l-.1-.625a1.862,1.862,0,0,0-1.966-1.308Zm10.844.585a3.517,3.517,0,0,0-1.1,2.371h4.646l.053.048q-3.435,15.279-3.892,17.662,0,1.548,1.926,1.8l.859-.05,3.228-14.469A48.442,48.442,0,0,1,164.2,7.406h2.433a2.571,2.571,0,0,0,1.913-.874A4.121,4.121,0,0,0,169.3,4.5h-.053l-.039-.048H158.849a2.6,2.6,0,0,0-1.525.585m10.892,7.173a6.668,6.668,0,0,0-3.02,3.7,57.594,57.594,0,0,0-1.381,6.684,4.759,4.759,0,0,0,.546,2.233,4.275,4.275,0,0,0,3.855,2.084H169.7a6.514,6.514,0,0,0,4.164-1.523A7.437,7.437,0,0,0,175.9,22.5a50.217,50.217,0,0,0,1.431-6.974,5.814,5.814,0,0,0-.248-1.457q-1.091-2.758-4.607-2.757l-.39.05-.353-.05a7.663,7.663,0,0,0-3.513.9m-1.133,9.441q1-5.2,1.536-5.974a3.24,3.24,0,0,1,3.02-1.372h.338q2.186,0,2.187,1.271v.287a44.98,44.98,0,0,1-1.041,5.027q-.585,3.08-3.373,3.081h-.833q-1.94,0-1.939-1.473,0-.848.105-.848M181.775,7.292q-.914,1.075-1.72,5.3Q178,21.736,178,22.522v.537a4.285,4.285,0,0,0,.806,2.22,5,5,0,0,0,3.515,1.635l1.718-.05h5.181c.094,0,.178-.353.248-1.061v-.237l-.105-.585a2.064,2.064,0,0,0-2.108-1.1h-4.322q-1.769,0-1.771-1.547v-.1q2.577-12.183,2.93-12.972a3.252,3.252,0,0,1,3.268-1.819h6.182c.1,0,.191-.355.261-1.061V5.846a2.132,2.132,0,0,0-2.266-1.4h-3.671q-4.165,0-6.09,2.842m12.435,8.12-2.577,11.4.1.1h6.393a6.457,6.457,0,0,0,3.331-.76h.039a1.886,1.886,0,0,0,1.744.76h.548q1.236-5.1,3.474-15.591v-.05h-6.3q-4.987,0-6.757,4.14m2.928,1a2.951,2.951,0,0,1,3.073-2.146h3.281L201.9,21.4q-.7,2.571-3.723,2.571h-2.733q.9-4.316,1.692-7.559m12.805-5.1-.05.05q-2.867,12.8-2.97,13.607v.287a1.081,1.081,0,0,0,.105.524,1.942,1.942,0,0,0,1.926,1.135h.6l1.328-5.737a25.157,25.157,0,0,1,1.394-5.413A2.846,2.846,0,0,1,214.5,14.3a2.846,2.846,0,0,0,1.823-1.048,3.594,3.594,0,0,0,.6-1.81l-.105-.085h-1.679a6.445,6.445,0,0,0-2.967.71q-.457-.759-2.174-.76Zm9.084,1.584a8,8,0,0,0-1.887,2.768,46.978,46.978,0,0,0-1.5,7.1,4.639,4.639,0,0,0,.351,1.771q1.095,2.38,4.867,2.382h5.884c.088,0,.169-.316.248-.949v-.287q0-1.522-1.9-1.72H221.07l-1.144-.1a1.409,1.409,0,0,1-1.146-1.383v-.138l.39-1.909h6.925a2.754,2.754,0,0,0,2.292-1.2,10.93,10.93,0,0,0,.793-3.618,4.521,4.521,0,0,0-.353-1.858,4.106,4.106,0,0,0-4.125-2.481h-1.3a6.835,6.835,0,0,0-4.374,1.622m1.249,3.055a3.117,3.117,0,0,1,3.125-1.72h.949l.353.048q1.21,0,1.392,1.622l-.3,1.571H219.82Z",
    transform: "translate(9.648 5.302)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToughEnoughLogo);
export default __webpack_public_path__ + "static/media/tough-enough-logo.33912ab76bd1a2b80cbed88ffc33ecd7.svg";
export { ForwardRef as ReactComponent };